module.exports = __webpack_public_path__ + "static/img/info.b80af32.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/info.png
// module id = ojtR
// module chunks = 1